import React, { useEffect, useMemo } from 'react';

import {
	useClassNames,
} from '@common';

import './FormItem.scss';
import { ValidateError } from 'async-validator';
import ReactTooltip from 'react-tooltip';
import { ValItem } from '@components';

interface FormItemProps {
	labelAlignment?: 'horizontal' | 'vertical',
	children: JSX.Element | JSX.Element[],
	label?: string | JSX.Element,
	className?: string,
	validationMessages?: ValidateError[],
	contentClassName?: string,
}

function FormItem(props: FormItemProps): JSX.Element {
	const {
		labelAlignment = 'vertical',
		className,
		children,
		label,
		validationMessages,
		contentClassName,
	} = props;

	const labelView = useMemo((): JSX.Element => {
		return label && (
			<>
				<label className="form-item__label">
					{label} <ValItem validationMessages={validationMessages} />
				</label>
			</>
		);
	}, [label, validationMessages]);

	useEffect(()=>{
        ReactTooltip.rebuild();
    }, [validationMessages]);

	const classes = useClassNames(
		'form-item',
		labelAlignment,
		className,
	);

	const contentClasses = useClassNames(
		'form-item__content',
		contentClassName
	)

	return (
		<div className={classes}>
			{labelView}
			<div className={contentClasses}>
				{children}
			</div>
		</div>
	);
}

const MemoisedFormItem = React.memo(FormItem);

export {MemoisedFormItem as FormItem};